// extracted by mini-css-extract-plugin
module.exports = {"detail":"about-module--detail--1L3Us"};